class Hamburger {

    constructor(passedElement) {
        let self = this;

        // Set elements
        self.elem = passedElement;
        self.target = document.getElementById(self.elem.getAttribute('href').replace('#', ''));
        self.textElem = self.elem.querySelector('.js-hamburger__text');

        // Set a default status
        self.status = 'closed';

        // Set some base settings
        self.settings = {
            roles: {
                elem: {
                    key: 'role',
                    value: 'button'
                }
            },
            states: {
                elem: {
                    active: {
                        attribute: 'aria-expanded',
                        attribute_value: 'true',
                        text: 'Hide menu'
                    },
                    default: {
                        attribute: 'aria-expanded',
                        attribute_value: 'false',
                        text: 'Show menu'
                    }
                },
                target: {
                    active: {
                        attribute: 'aria-hidden',
                        attribute_value: 'false'
                    },
                    default: {
                        attribute: 'aria-hidden',
                        attribute_value: 'true'
                    }
                }
            },
            noScrollClass: 'is-no-scroll'
        };
    }

    init() {
        let self = this;

        // There's no target menu, so bail out
        if(self.target === null) {
            console.warn('Hamburger: No target menu found. Exiting.');
            return;
        }

        // Set elem roles because it should now behave as a button
        self.elem.setAttribute(self.settings.roles.elem.key, self.settings.roles.elem.value);

        // Set the status as open if the menu has already been targeted
        if(window.location.hash === self.elem.getAttribute('href')) {
            self.status = 'open';
            self.toggle('show');
        }

        // Set default status if not
        else {
            self.toggle('hide');
        }
        
        // Bind a click event to the trigger
        self.elem.addEventListener('click', (evt) => {
            evt.preventDefault();

            self.toggle();
        });
        
        // Hide if escape key is hit
        document.addEventListener('keyup', (evt) => {

            if(evt.keyCode === 27) {
                self.toggle('hide');
            }
        });
    }

    toggle(command) {
        let self = this;

        // Calculate command if not passed in
        if(typeof(command) === 'undefined') {
            command = (self.status === 'open' ? 'hide' : 'show');
        }

        switch(command) {
            case 'hide':
            default:
                self.elem.setAttribute(self.settings.states.elem.default.attribute, self.settings.states.elem.default.attribute_value);
                self.target.setAttribute(self.settings.states.target.default.attribute, self.settings.states.target.default.attribute_value);

                if(self.textElem !== null) {
                    self.textElem.innerHTML = self.settings.states.elem.default.text;
                }

                // Set status 
                self.status = 'closed';

                // Remove no scroll class from body
                document.body.classList.remove(self.settings.noScrollClass);

                break;
            case 'show':
                self.elem.setAttribute(self.settings.states.elem.active.attribute, self.settings.states.elem.active.attribute_value);
                self.target.setAttribute(self.settings.states.target.active.attribute, self.settings.states.target.active.attribute_value);

                if(self.textElem !== null) {
                    self.textElem.innerHTML = self.settings.states.elem.active.text;
                }

                // Set status 
                self.status = 'open';

                // Set no scroll class on body
                document.body.classList.add(self.settings.noScrollClass);

                break;
        }
    }
}

export default Hamburger;